module.exports = __webpack_public_path__ + "img/bg3.684dc3dd.jpg";